module.exports = __webpack_public_path__ + "img/seedBag03.c751c329.jpg";